import { formatLocalDateTime as formatLocalDateTimeFn, formatLocalDate as formatLocalDateFn, toDateTimePickerString } from './dateUtils';

// Re-export from dateUtils for direct use
export { formatLocalDateTime, formatLocalDate, formatLocalDateTimeWithTime } from './dateUtils';

/**
 * Format a date/time string for display.
 * @param dateTime - ISO string or null
 * @param hasTime - Whether to include time in the output
 * @returns Formatted string like "10.12.2025" or "10.12.2025 14:30"
 */
export const formatDateTime = (dateTime: string | null | undefined, hasTime: boolean): string => {
  return formatLocalDateTimeFn(dateTime, hasTime);
};
